import React, {CSSProperties, ReactNode} from "react";
import FunctionHelper from "../helper/FunctionHelper";
import PortalPureComponent from "./PortalPureComponent";

interface ProgressBarProperties {
	unit?: string;
	label?: ReactNode;
	style?: CSSProperties;
	className?: string;
	hidden?: boolean;
	bars?: Array<{
		value: number;
		className?: string;
		style?: CSSProperties;
	}>;
	marker?: Array<{
		value: number;
		className?: string;
		style?: CSSProperties;
	}>;
}

export default class ProgressBar extends PortalPureComponent<ProgressBarProperties, any> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let bars: Array<ReactNode> = [];
		for (let bar of FunctionHelper.applyValue(this.props.bars, [])) {
			bars.push(
				<div className={"bar" + (FunctionHelper.exists(bar.className) ? " " + bar.className : "")}
					 key={bars.length} style={{...bar.style, width: bar.value + "%"}}/>
			);
		}

		let marker: Array<ReactNode> = [];
		for (let mark of FunctionHelper.applyValue(this.props.marker, [])) {
			marker.push(
				<div className={"marker" + (FunctionHelper.exists(mark.className) ? " " + mark.className : "")}
					 key={marker.length} style={{...mark.style, left: mark.value + "%"}}/>
			);
		}

		return (
			<div className={"progress-bar" +
				(FunctionHelper.exists(this.props.className) ? " " + this.props.className : "")}
				 style={this.props.style} hidden={this.props.hidden}>
				{bars}
				{marker}
				{FunctionHelper.exists(this.props.label) &&
					<div className="label">
						{this.props.label}{FunctionHelper.exists(this.props.unit) ? " " + this.props.unit : " %"}
					</div>
				}
			</div>
		);
	}
}